import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import { LoginPage } from "./pages/login/LoginPage";
import { ResetPasswordPage } from "./pages/login/ResetPasswordPage";
import { LibraryPage } from "./pages/library/LibraryPage";
import { SharedListPage } from "./pages/shared/SharedListPage";
import { PrivacyPage } from "./pages/legal/PrivacyPage";
import "./styles/comon.css";

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, staleTime: 10_000 } },
});

function RequireUser({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

/** geargrams.com itself is the login page (no redirect to /login); signed-in users go to the library. */
function Home() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/library" replace />;
  return <LoginPage />;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/list" element={<SharedListPage />} />
      <Route path="/list/:id" element={<SharedListPage />} />
      <Route path="/legal/privacy" element={<PrivacyPage />} />
      <Route
        path="/library/*"
        element={
          <RequireUser>
            <LibraryPage />
          </RequireUser>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}
